import React from 'react';

/**
 * LegacyFA Logo component — uses actual logo assets from /public/logo/
 * @param {Object} props
 * @param {'sm' | 'md' | 'lg'} props.size - Logo size variant
 * @param {boolean} props.showText - Whether to show text next to icon
 * @param {string} props.className - Additional CSS classes
 */
const LegacyFALogo = ({ size = 'md', showText = true, className = '' }) => {
  const sizes = {
    sm: { icon: 'h-8', text: 'h-8' },
    md: { icon: 'h-10', text: 'h-10' },
    lg: { icon: 'h-14', text: 'h-14' },
  };

  const s = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <img
        src="/logo/symbol.png"
        srcSet="/logo/symbol@2x.png 2x"
        alt="LegacyFA"
        className={`${s.icon} w-auto`}
      />
      {showText && (
        <img
          src="/logo/text.png"
          srcSet="/logo/text@2x.png 2x"
          alt="LegacyFA Financial Advisory"
          className={`${s.text} w-auto`}
        />
      )}
    </div>
  );
};

export default LegacyFALogo;
